/**
 * Central runtime-environment config. Three environments (README "Environments"):
 *
 *   dev  — UI-only. No backend exists; MSW serves every endpoint in-browser.
 *   test — integrated. The UI calls the real service on the test host
 *          (https://fenceauth-test.apps.taskefi.com).
 *   prod — production. Same-origin BFF by default; set VITE_API_URL at
 *          deploy time if the API lives on another host.
 *
 * Selected via Vite modes (.env.development / .env.test / .env.production);
 * switch with `npm run dev` / `dev:test` / `build:test` / `build`.
 */

export type AppEnv = 'dev' | 'test' | 'prod'

function resolveAppEnv(): AppEnv {
  const raw = import.meta.env.VITE_APP_ENV
  if (raw === 'dev' || raw === 'test' || raw === 'prod') return raw
  return import.meta.env.PROD ? 'prod' : 'dev'
}

export const APP_ENV: AppEnv = resolveAppEnv()

/** API host prefix for every request, including the hosted-login navigation. Empty = same origin. */
export const API_BASE_URL: string = import.meta.env.VITE_API_URL ?? ''

/** Mock mode boots MSW and never touches a network (dev default). */
export const IS_MOCK: boolean = import.meta.env.VITE_API_MODE === 'mock'
